import { Routes, Route } from 'react-router-dom'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import ScrollToTop from './components/ScrollToTop'
import Home from './components/pages/Home'
import Services from './components/pages/Services'
import About from './components/pages/About'
import Contact from './components/pages/Contact'
import StrategicPartnerships from './components/pages/StrategicPartnerships'
import Portfolio from './components/pages/Portfolio'
import BecomePartner from './components/pages/BecomePartner'
import ApplyInternship from './components/pages/ApplyInternship'
import Career from './components/pages/Career'
import Cybersecurity from './components/pages/Cybersecurity'
import TrainingConsulting from './components/pages/TrainingConsulting'
import BusinessPlatform from './components/pages/BusinessPlatform'
import Academy from './components/pages/Academy'
import JoinNetwork from './components/pages/JoinNetwork'
import CloudSolutions from './components/pages/CloudSolutions'
import WebDevelopment from './components/pages/WebDevelopment'

function App() {
  return (
    <div className="flex flex-col min-h-screen bg-white dark:bg-gray-900">
      <ScrollToTop />
      <Navbar />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/partnerships" element={<StrategicPartnerships />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/partnership" element={<BecomePartner />} />
          <Route path="/internship" element={<ApplyInternship />} />
          <Route path="/career" element={<Career />} />
          <Route path="/cybersecurity" element={<Cybersecurity />} />
          <Route path="/cloud-solutions" element={<CloudSolutions />} />
          <Route path="/web-development" element={<WebDevelopment />} />
          <Route path="/training-consulting" element={<TrainingConsulting />} />
          <Route path="/business-platform" element={<BusinessPlatform />} />
          <Route path="/academy" element={<Academy />} />
          <Route path="/network" element={<JoinNetwork />} />
        </Routes>
      </main>
      <Footer />
    </div>
  )
}

export default App